import { render, staticRenderFns } from "./MultiSplitModule.vue?vue&type=template&id=a4f5d9c0&"
import script from "./MultiSplitModule.vue?vue&type=script&lang=js&"
export * from "./MultiSplitModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports